module.exports = __webpack_public_path__ + "img/shots.16012dc8.jpg";